import { TwinDictionary } from '../../utils/globals/dictionary'

export interface TitleQuoteCostProps {
    cost: TwinDictionary
}

const TitleQuoteCost: React.FC<TitleQuoteCostProps> = ({ cost }) => {
    return (
        <div className='flex justify-between items-center mb-17'>
            <span className='regular18'>
                {cost.name}
            </span>
        </div>
    )
}

export default TitleQuoteCost